import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMore = () => {
  return (
    <g>
      <path d="M2 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm12 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
    </g>
  );
};

export default withIcon(IconMore);
